import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getFormValues, getFormSyncErrors } from "redux-form";
import { withRouter } from "react-router-dom";
import cx from "classnames";
import Tab from "components/Tab";
import styles from "styles/modules/searchPage.module.scss";
import { withTranslation } from "react-i18next";
// import GridActionsPopup from "./GridActionsPopup";
import { updateCurrentTabField } from "actions/tabs";
import { bindActionCreators } from "redux";
import { queriesContentUpdate } from "actions/content";
import { safeQuery } from "helpers";
import permissions, { checkPermissions } from "../../config/permissions";
import List from "./List";
import { openExportWizardModal } from '../../reducers/exportWizard';

// OLD LISTS APPROACH
// import EventsList from "./EventsList";
// import ResourcesList from "./ResourcesList";
// import ServicesList from "./ServicesList";
// import TasksList from "./TasksList";
// import CustomersList from "./CustomersList";
// import AppealsList from "./AppealsList";
// import ContactPersonList from "./ContactPersonList";
import Loader from "../../pages/Ordering/common/Loader";

import { updateCurrentTabUrl } from "../../actions";
import { setCurrentTab } from "actions/index";

// appeal, contact_person grids are still not "dynamic"
const SUPPORTED_TABS = ["task", "resource", "spec", "clevent", "customer", "appeal", "contact_person"];

const FORM_NAME = (entity, hash) => `search-${entity}-${hash}-filters-main`;

const tabContent = {
    task: "task",
    resource: "resource",
    spec: "spec",
    clevent: "clevent",
    contact_person: "contact_person",
    customer: "customer",
    appeal: "appeal",
};

// const COMPONENTS = {
//     resource: ResourcesList,
//     spec: ServicesList,
//     clevent: EventsList,
//     task: TasksList,
//     customer: CustomersList,
//     appeal: AppealsList,
//     contact_person: ContactPersonList,
// };

const LIST_SHARED = {
    limit: 50,
    method: "post",
};
const LIST_INIT = {
    resource: {
        ...LIST_SHARED,
        key: "resource",
        code: "SPEC_RESOURCE",
        configUrlKey: "config_grid",
        configKey: "resource",
        configCode: "RESOURCE",
        type: "spec",
    },
    spec: {
        ...LIST_SHARED,
        key: "service",
        code: "SPEC_INSTANCE",
        configUrlKey: "config_grid",
        configKey: "service",
        configCode: "SERVICE",
        type: "spec",
    },
    clevent: {
        ...LIST_SHARED,
        key: "calendar_events",
        code: "FTOP_SEARCH_CLEVENT",
        configUrlKey: "config_grid",
        configKey: "calendar_events",
        configCode: "FTOP_CLEVENT",
        type: "clevent",
    },
    task: {
        ...LIST_SHARED,
        key: "task",
        code: "ORDER_TASK",
        configUrlKey: "config_grid",
        configKey: "task",
        configCode: "TASK",
        type: "task",
    },
    customer: {
        ...LIST_SHARED,
        key: "customers",
        code: "CUSTOMER",
        configUrlKey: "config_grid",
        configKey: "customer",
        configCode: "CUSTOMER",
        type: "customer",
    },
    appeal: {
        ...LIST_SHARED,
        key: "appeal",
        code: "INTERACTION_REQUEST",
        // filterObject: [],
        configUrlKey: "config_grid",
        configKey: "appeal",
        configCode: "INTERACTION_REQUEST",
        type: "appeal",
    },
    contact_person: {
        ...LIST_SHARED,
        key: "contact_person",
        code: "CONTACT_PERSON",
        // filterObject: [],
        configUrlKey: "config_grid",
        configKey: "contact_person",
        configCode: "CONTACT_PERSON",
        type: "contact_person",
    },
};

function mapStateToProps(state, props) {
    const { hash, entity } = props.match.params;

    const attributesFilters = state.attributesFilters && state.attributesFilters[`search-${entity}`];

    let total = state.search.total;

    // todo: all grids except clevent (calendar) could be unified into a single one configurable via props
    if (entity === "task") {
        total = _.get(state, `grid.task_${hash}.result.total`, 0);
    }

    if (entity === "resource") {
        total = _.get(state, `grid.resource_${hash}.result.total`, 0);
    }

    if (entity === "spec") {
        total = _.get(state, `grid.service_${hash}.result.total`, 0);
    }

    if (entity === "clevent") {
        total = _.get(state, `grid.calendar_events_${hash}.result.total`, 0);
    }

    if (entity === "customer") {
        total = _.get(state, `grid.customers_${hash}.result.total`, 0);
    }

    if (entity === "appeal") {
        total = _.get(state, `grid.appeal_${hash}.result.total`, 0);
    }

    if (entity === "contact_person") {
        total = _.get(state, `grid.contact_person_${hash}.result.total`, 0);
    }

    return {
        tabs: state.tabs,
        total,
        canSearchCustomer: checkPermissions(permissions.SearchOperations.search_customer),
        canSearchContactPersons: checkPermissions(permissions.SearchOperations.search_contactPersons),
        canSearchEvents: checkPermissions(permissions.CalendarOperations.view_calendar_event),
        canSearchServices: checkPermissions(permissions.SearchOperations.search_spec),
        canSearchResource: checkPermissions(permissions.SearchOperations.search_res),
        canSearchTasks: checkPermissions(permissions.SearchOperations.search_order_task),
        currentSearchQuery: state.search.query,

        allFilterFields: attributesFilters && attributesFilters.attributes,
        isExportAllowed: checkPermissions(permissions.SearchOperations.search_export),
        formValues: getFormValues(FORM_NAME(entity, hash))(state),
        formErrors: getFormSyncErrors(FORM_NAME(entity, hash))(state),
        query: state.search.searches[hash] || "",
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                updateCurrentTabField,
                queriesContentUpdate,
            },
            dispatch
        ),
        setCurrentTab: payload => dispatch(setCurrentTab(payload)),
        updateCurrentTabUrl: path => dispatch(updateCurrentTabUrl(path)),
        openExportWizardModal: () => dispatch(openExportWizardModal())
    };
}

@withTranslation()
@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class TabContentNewGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPopupOpen: false,
        };
        this.togglePopup = this.togglePopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.getPath = this.getPath.bind(this);
        this.renderTab = this.renderTab.bind(this);
    }

    componentDidMount() {
        const currentTab = this.props.tabs.current;
        const { hash, entity } = this.props.match.params;
        const urls = SUPPORTED_TABS.map(tab => this.getPath(tab));
        if (!currentTab || !urls.includes(currentTab.url)) {
            this.updateCurrentTab();
        }
        if (currentTab && currentTab.type === `search_${hash}` && !urls.includes(currentTab.url)) {
            this.props.updateCurrentTabUrl(this.getPath(entity));
        }
    }

    componentDidUpdate(prevProps) {
        const prevHash = prevProps.match.params.hash;
        const prevEntity = prevProps.match.params.entity;
        const { hash, entity } = this.props.match.params;
        if (prevHash !== hash) {
            this.updateCurrentTab();
        }
        if (prevHash === hash && prevEntity !== entity) {
            this.updateCurrentTab();
        }
    }

    updateCurrentTab() {
        const { hash, entity } = this.props.match.params;
        const url = this.getPath(entity);
        this.props.setCurrentTab({
            noRequest: true,
            isExact: true,
            params: this.props.match.params,
            path: this.props.match.path,
            url: url,
            name: () => (this.props.currentSearchQuery ? decodeURIComponent(this.props.currentSearchQuery) : "search"),
            queryKey: () => entity,
            storeName: () => entity,
            tabType: `search_${hash}`,
        });
    }

    togglePopup() {
        this.setState(prevState => ({ isPopupOpen: !prevState.isPopupOpen }));
    }

    closePopup() {
        if (this.state.isPopupOpen) this.setState({ isPopupOpen: false });
    }

    getPath(val) {
        const aPath = this.props.history.location.pathname.split("/");
        aPath[2] = val;
        return safeQuery(aPath.join("/"));
    }

    renderTab(tab, index) {
        const url = this.getPath(tab);
        const onClick = tab => {
            this.props.actions.updateCurrentTabField("queryKey", tab);
            this.props.actions.updateCurrentTabField("url", url);
        };
        return <Tab val={tab} key={index} getPath={() => this.getPath(tab)} onClick={onClick} />;
    }

    render() {
        const {
            total,
            match,
            t,
            canSearchContactPersons,
            canSearchCustomer,
            canSearchEvents,
            canSearchServices,
            canSearchResource,
            canSearchTasks,
            // isExportAllowed,
            allFilterFields,
            formValues,
            formErrors,
            query,
            isExportAllowed,
            openExportWizardModal,
        } = this.props;
        const { hash, entity } = match.params;

        const tabContentClone = { ...tabContent };

        const iconClass = cx("icon-kebab-vert", styles.actionButton, {});

        if (!canSearchContactPersons) {
            delete tabContentClone.contact_person;
        }

        if (!canSearchCustomer) {
            delete tabContentClone.customer;
        }

        if (!canSearchEvents) {
            delete tabContentClone.clevent;
        }

        // if (!canSearchServices) {
        //     delete tabContentClone.resource;
        //     delete tabContentClone.spec;
        // }
        if (!canSearchServices) {
            delete tabContentClone.spec;
        }

        if (!canSearchResource) {
            delete tabContentClone.resource;
        }

        if (!canSearchTasks) {
            delete tabContentClone.task;
        }

        // const ActiveList = COMPONENTS[entity];

        const listInit = LIST_INIT[entity];

        return (
            <Fragment>
                <div className={styles.searchHeader}>
                    <div className={styles.resultsTitle}>
                        <span className={styles.title}>{t("searchResult")}</span>
                        <span className={styles.total}>{total}</span>
                    </div>
                    <div className={styles.tabsWrapper}>
                        <div id="card-bottom-row" className="column">
                            <div className="top-right">{Object.keys(tabContentClone).map(this.renderTab)}</div>
                        </div>
                        {/* {isExportAllowed && <button className={iconClass} onClick={this.togglePopup} />}
                        {this.state.isPopupOpen && (
                            <GridActionsPopup isExportAllowed={isExportAllowed} onClose={this.closePopup} />
                        )} */}
                    </div>
                </div>
                <div className={cx("contentGridTab", "gridWrapper", "ordering-component-ui-core-wrapper")}>
                    {!allFilterFields && <Loader />}
                    {allFilterFields && (
                        // <ActiveList formValues={formValues} query={query} allFilterFields={allFilterFields} />
                        <List
                            listInit={listInit}
                            formValues={formValues}
                            formErrors={formErrors}
                            query={query}
                            entity={entity}
                            selectItemPath={entity}
                            allFilterFields={allFilterFields}
                            onGridExport={isExportAllowed && openExportWizardModal}
                            key={`${entity}-${hash}`}
                        />
                    )}
                </div>
            </Fragment>
        );
    }
}

export default TabContentNewGrid;
